
import React from 'react';
import { User, Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface ProfileBannerProps {
  user: User;
  language: Language;
  currentPlan: any;
  onManageBilling: () => void;
}

const ProfileBanner: React.FC<ProfileBannerProps> = ({ user, language, currentPlan, onManageBilling }) => {
  const t = TRANSLATIONS[language];

  return (
    <div className={`mb-8 rounded-[2.5rem] p-8 text-white bg-gradient-to-br ${currentPlan.bg} shadow-2xl shadow-${currentPlan.color}-500/20 relative overflow-hidden group`}>
       <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3"></div>
       <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-6">
             <div className="w-20 h-20 rounded-[2rem] bg-white/20 backdrop-blur-md flex items-center justify-center text-4xl shadow-lg border border-white/10">
                <i className={`fas ${currentPlan.icon}`}></i>
             </div>
             <div>
                <h2 className="text-3xl font-black mb-1">{currentPlan.label}</h2>
                <p className="text-xs font-medium opacity-80">{user.email}</p>
                <div className="mt-3 inline-flex items-center gap-2 bg-black/20 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-wider backdrop-blur-sm">
                   <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span> {user.plan === 'free' ? 'Starter' : 'Active'}
                </div>
             </div>
          </div>
          <div className="flex flex-col gap-3 w-full md:w-auto">
             <button onClick={onManageBilling} className="px-8 py-3 bg-white text-slate-900 rounded-xl text-xs font-black hover:scale-105 active:scale-95 transition-all shadow-lg flex items-center justify-center gap-2">
                <i className="fas fa-gear"></i> {t.manageBilling}
             </button>
          </div>
       </div>
    </div>
  );
};
export default ProfileBanner;
